module.exports = __webpack_public_path__ + "img/picto-likes.7d538671.svg";